import { stringify } from 'qs';
import { BooleanParam, encodeQueryParams, JsonParam, StringParam } from 'use-query-params';

import { JobFilters } from 'api/jobs';
import { JobsTab } from 'components/StudyDashboard/useStudyDashboardTabState';
import { encodeQueryParamsUsingSchema } from './useEncodedFilters/helpers';

export interface JobsPageUrlProps {
  newPage?: number;
  labId?: string;
  jobsFilters?: JobFilters;
}

const getSearchStringForJobsPage = ({ labId, jobsFilters }: JobsPageUrlProps): string =>
  encodeQueryParamsUsingSchema(
    {
      filters: { studyId: jobsFilters?.studyId },
      labId,
      jobsFilters,
      studyDashboardTab: JobsTab,
    },
    {
      jobsFilters: JsonParam,
      filters: JsonParam,
      labId: StringParam,
      studyDashboardTab: StringParam,
    }
  );

export const getLinkToJobsPage = (props: JobsPageUrlProps) => {
  const encodedParams = getSearchStringForJobsPage(props);

  return {
    pathname: `/procedures`,
    search: `?${encodedParams}`,
    hash: '',
  };
};
export const getUrlToJobsPage = (props: JobsPageUrlProps) => {
  const linkToJobsPage = getLinkToJobsPage(props);
  return `${linkToJobsPage.pathname}${linkToJobsPage.search}`;
};

/** The study's Jobs tab with the job's details drawer open. */
export const getUrlToJobDetails = ({
  studyId,
  labId,
  jobId,
  archived,
}: {
  studyId: string;
  labId: string;
  jobId: string;
  archived?: true;
}) => {
  const encodedQuery = encodeQueryParams(
    {
      filters: JsonParam,
      labId: StringParam,
      studyDashboardTab: StringParam,
      jobDrawerOpen: BooleanParam,
      currentJobId: StringParam,
      archived: BooleanParam,
    },
    {
      filters: { studyId },
      labId,
      studyDashboardTab: JobsTab,
      jobDrawerOpen: true,
      currentJobId: jobId,
      archived,
    }
  );

  return `/procedures?${stringify({ ...encodedQuery })}`;
};
